import * as R from 'ramda';

export interface ContextMenuAction<T> {
    click?: (arg?: T) => void;
    divider?: boolean;
    icon?: (arg?: T) => string;
    enabled?: (arg?: T) => boolean;
    text?: (arg?: T) => string;
    tooltip?: (arg?: T) => string;
    visible?: (arg?: T) => boolean;
}

export interface GenericItem<T> {
    disabled: boolean;
    name: string;
    source: T;
    tag: string;
}

export const defaultContextMenuAction = [
    {
        enabled: R.F,
        text: R.always('N/A'),
        visible: R.T
    }
] as ContextMenuAction<any>[];
